import React from "react";
import {
  CalendarDays,
  ChevronLeft,
  ChevronRight,
  LocateFixed,
  Maximize2,
  Minimize2,
  Pause,
  Play,
  Square,
} from "lucide-react";

export default function PlaybackController({
  isPlaying = false,
  onPlayPause,
  onStop,
  onStepBack,
  onStepForward,
  playbackSpeed = 1,
  speedOptions = [],
  onSpeedChange,
  progress = 0,
  onProgressClick,
  elapsedLabel = "0s",
  totalLabel = "0s",
  onFullscreen,
  onCalendar,
  isFullscreen = false,
  followVehicle = true,
  onFollowToggle,
}) {
  return (
    <div className="history-playback-controller history-playback-floating">
      <div className="history-controller-main">
        <div className="history-controller-actions">
          <button type="button" className="history-control-icon" onClick={onStepBack} aria-label="Previous point">
            <ChevronLeft size={16} />
          </button>
          <button type="button" className="history-play-button" onClick={onPlayPause} aria-label="Play or pause">
            {isPlaying ? <Pause size={22} /> : <Play size={22} />}
          </button>
          <button type="button" className="history-control-icon" onClick={onStop} aria-label="Stop playback">
            <Square size={15} />
          </button>
          <button type="button" className="history-control-icon" onClick={onStepForward} aria-label="Next point">
            <ChevronRight size={16} />
          </button>
        </div>

        <div className="history-speed-group">
          {speedOptions.map((speed) => (
            <button
              key={speed}
              type="button"
              className={`history-speed-pill ${Number(playbackSpeed) === Number(speed) ? "active" : ""}`}
              onClick={() => onSpeedChange?.(Number(speed))}
            >
              {speed}x
            </button>
          ))}
        </div>
      </div>

      <div className="history-controller-progress">
        <div className="history-controller-time">
          <span>{elapsedLabel}</span>
          <span>/</span>
          <span>{totalLabel}</span>
        </div>
        <div className="history-progress-bar" onClick={onProgressClick} role="presentation">
          <div className="history-progress-fill" style={{ width: `${progress}%` }} />
          <div className="history-progress-thumb" style={{ left: `calc(${progress}% - 9px)` }} />
        </div>
      </div>

      <div className="history-controller-tools">
        <button type="button" className="history-control-icon" onClick={onCalendar} aria-label="Jump to filters">
          <CalendarDays size={16} />
        </button>
        <button
          type="button"
          className={`history-control-icon ${followVehicle ? "is-active" : ""}`}
          onClick={onFollowToggle}
          aria-label={followVehicle ? "Stop following vehicle" : "Follow vehicle"}
          title={followVehicle ? "Following vehicle" : "Follow vehicle"}
        >
          <LocateFixed size={16} />
        </button>
        <button
          type="button"
          className="history-control-icon"
          onClick={onFullscreen}
          aria-label={isFullscreen ? "Exit fullscreen map" : "Fullscreen map"}
        >
          {isFullscreen ? <Minimize2 size={16} /> : <Maximize2 size={16} />}
        </button>
      </div>
    </div>
  );
}
